import { render, staticRenderFns } from "./CollectionView.vue?vue&type=template&id=5c2f9102&scoped=true&"
import script from "./CollectionView.vue?vue&type=script&lang=js&"
export * from "./CollectionView.vue?vue&type=script&lang=js&"
import style0 from "./CollectionView.vue?vue&type=style&index=0&id=5c2f9102&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2f9102",
  null
  
)

export default component.exports